import React, { PropsWithChildren } from "react";

import UiTooltipUnsupported from "@/components/Ui/Tooltip/Unsupported";
import { classNames } from "@/utils";

export default function GridCellUnsupported({ children, isUnsupported }: PropsWithChildren<{ isUnsupported?: boolean }>) {
  return (
    <UiTooltipUnsupported enable={isUnsupported}>
      <span className={classNames(isUnsupported && "opacity-44")}>{children}</span>
    </UiTooltipUnsupported>
  );
}
